import { useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Affix, Card, Button } from "antd";

import PackingOperatorMappingForm from "./Form";
import Header from "components/Common/Header";
import { isMobileView } from "components/Common/AppHelper";

const AddOrUpdatePackingOperatorMapping = (props) => {
  const { width } = props;
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = !!id;
  const propertyFormRef = useRef(null);

  const discartForm = () => {
    navigate("/configuration/packing-operator-mapping");
  };

  const submitForm = () => {
    propertyFormRef.current?.submit();
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title={isEdit ? "Edit Packer Man Mapping" : "Add Packer Man Mapping"}
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discartForm()}>
                Discard
              </Button>,
              <Button
                size="small"
                key={2}
                type="primary"
                onClick={() => submitForm()}
              >
                {isEdit ? "Update Packer Man Mapping" : "Add Packer Man Mapping"}
              </Button>,
            ]}
          />
        </Card>
      </Affix>
      <PackingOperatorMappingForm ref={propertyFormRef} />

    </>
  );
};

export default AddOrUpdatePackingOperatorMapping;

